var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3534_170303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 0H1.78125C0.799187 0 0 0.820732 0 1.82927V14.0244C0 15.0329 0.799187 15.8537 1.78125 15.8537H3.5625V18.9024C3.5625 19.1268 3.68244 19.3341 3.876 19.4402C3.96387 19.489 4.06006 19.5122 4.15625 19.5122C4.27144 19.5122 4.38662 19.4781 4.48519 19.4098L9.67931 15.8537H17.2188C18.2008 15.8537 19 15.0329 19 14.0244V1.82927C19 0.820732 18.2008 0 17.2188 0ZM17.8125 14.0244C17.8125 14.361 17.5465 14.6341 17.2188 14.6341H9.5C9.38244 14.6341 9.26844 14.6695 9.17106 14.7366L4.75 17.7634V15.2439C4.75 14.9073 4.484 14.6341 4.15625 14.6341H1.78125C1.4535 14.6341 1.1875 14.361 1.1875 14.0244V1.82927C1.1875 1.49268 1.4535 1.21951 1.78125 1.21951H17.2188C17.5465 1.21951 17.8125 1.49268 17.8125 1.82927V14.0244ZM8.4075 4.45976C8.35763 4.04756 8.66994 3.68293 9.07487 3.68293H9.92631C10.3312 3.68293 10.6436 4.04756 10.5937 4.45976L10.1686 7.9561C10.127 8.30122 9.84081 8.56098 9.50119 8.56098C9.16156 8.56098 8.87537 8.30122 8.83381 7.9561L8.40869 4.45976H8.4075ZM10.6875 10.9756C10.6875 11.6488 10.1555 12.1951 9.5 12.1951C8.8445 12.1951 8.3125 11.6488 8.3125 10.9756C8.3125 10.3024 8.8445 9.7561 9.5 9.7561C10.1555 9.7561 10.6875 10.3024 10.6875 10.9756Z",
    fill: "#6d4096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3534_170303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19.5122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplain);
export default __webpack_public_path__ + "static/media/complain.a3d70b21d23b71fc342497887a467c99.svg";
export { ForwardRef as ReactComponent };